import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from "@material-ui/icons/Save"; // save
import CloseIcon from '@material-ui/icons/Close';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Slide from "@material-ui/core/Slide";
import CustomInput from "components/CustomInput/CustomInput.js";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import otpModalStyle from "assets/jss/material-dashboard-react/views/pageStyle";
import { Link } from "react-router-dom";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import brandTheme from "brandTheme/Theme";
import { Button } from "@material-ui/core";
import ToastModal from "views/components/ToastModal";
const useStyles = makeStyles(otpModalStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const OtpModal = ({ showModal, closeModal, record, validate, Otp, handleClose, ResendOtp, noResendOtp,show,header,message }) => {
  const classes = useStyles();
  const [code1, setCode1] = useState('');
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

  };
  useEffect(()=>{
    setCode1('')
  }, []);
  useEffect(()=>{
    if(message){
    toastUpdate("Information", message, true);
    }
  },[message])
  return (
    <div className={classes.container}>
      <Dialog
        classes={{
          root: classes.center,
        }}
        open={showModal}
        width={'sm'}
        
        disableEscapeKeyDown
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader} style={{width: 300}}>
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
          justifyContent="center"
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
            <form onSubmit={(e) => {
              e.preventDefault();
              Otp(code1);
            }}>
              <GridContainer justifyContent="center">
                <GridItem xs={8} sm={8} md={8}>
                  <h5 className={classes.subTitle}>Enter your OTP Code</h5>
            
                  <CustomeTextField
                    label="OTP Code"
                    required
                    value={code1}
                    setState={setCode1}
                  />
                </GridItem>
              </GridContainer>
            
              <div className={classes.center}>
                <Button
                  type="submit"
                  round={false}
                  className={classes.nextButton}
                >
                  <span style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'inherit'}}>
                    <span >
                      <SaveIcon /> 
                    </span>
                    <span>Verify</span>
                  </span>
                </Button>
              </div>
              {!noResendOtp && <div>
                    <span
                      style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
                      onClick={ResendOtp}
                    >
                      Resend OTP
                    </span>
                  </div>
                }
            </form>
            </GridItem>
          </GridContainer>
        
   {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

OtpModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  record: PropTypes.object,
  validate: PropTypes.func
};

export default OtpModal;
